import {Component, Input, OnInit} from '@angular/core';
import {CCPXDEVEVHI_HP, cIO_COMPLEX_DEVICE} from "../complexDevices";
import { eCPXDEV_TYPE } from '../eCPXDEV_TYPE';

@Component({
  selector: 'app-complex-devices-details',
  templateUrl: './complex-devices-details.component.html',
  styleUrls: ['./complex-devices-details.component.css']
})
export class ComplexDevicesDetailsComponent implements OnInit {
  @Input()  device: cIO_COMPLEX_DEVICE | undefined;
  readonly eCPXDEV_TYPE: typeof eCPXDEV_TYPE = eCPXDEV_TYPE;

  constructor() { }

  ngOnInit(): void {
  }

}
